export enum UI_ROUTES {
  baseURL = '/',
  emailConfirm = '/email-confirm',
  sell = '/Sell',
  buy = '/Buy',
  modify = '/modify',
  symbol = '/symbol',
  overview = '/overview',
  authResult = '/auth-result',
  discover = '/discover',
  paymentSuccess = '/payment-success',
  paymentError = '/payment-error',
  paymentCancel = '/payment-cancel',
  demoAccountActivationError = '/demo-plan-error',
  signUp = '/sign-up',
  firstEnroll = '/enroll-personal-info', // TODO delete this when ace website is not using it
  firstEnroll2 = '/register',
  secondEnroll = '/enroll-auth-info',
  enrollPhoneVerification = '/enroll-phone-verification',
  enrollPhoneVerificationOtp = '/enroll-phone-verification-otp',
  enrollPhoneVerified = '/enroll-phone-verified',
  paymentMethodSelection = '/payment-method-selection',
  cryptoPayment = '/crypto-payment',
  error = '/error',
  addYourBankAccount = '/add-your-bank-account',
  uploadBankStatement = '/upload-bank-statement',
  dividendPayersAndHighGrowthCompaniesPath = '/dividend-payers-high-growth-companies',
  epicMoversToday = '/epic-movers-today',
  popularGroup = '/popular-group',
  earningsCalendar = '/earnings-calendar',
  marketCapRadar = '/market-cap-radar',
  tradeHistory = '/trade-history',
  payoutHistory = '/payout-history',
  myProfile = '/my-profile',
  dashboard = '/dashboard',
  myAccountNotifications = '/my-account-notifications',
  myAccountPersonalDetails = '/my-account-personal-details',
  funds = '/funds',
  withdrawalAmount = '/withdrawal-amount',
  withdrawCryptoAmount = '/withdraw-crypto-amount',
  searchSymbolsMob = '/searchSymbol',
  tradingView = '/tradingView-chart',
  cashFlowStatement = '/cashflow-statement',
  incomeStatement = '/income-statement',
  balancesheetStatement = '/balancesheet-statement',
  fiftyTwoWeekHighLow = '/52-week-high-low',
  gapTrackers = '/gap-trackers',
  products = '/products',
  payouts = '/payouts',
  referrals = '/referrals',
  payoutsMethods = '/methods',
  planDetails = '/plan-details',
  searchCountryCode = '/search-country-code',
  addCryptoAddress = '/add-crypto-address'
}

export const UI_ROUTE_MOCKED = '/mocked';
